module.exports = __webpack_public_path__ + "img/MES3Indice6.b88f0846.png";